export enum NavigationId {
  HotelByCity = "1Sk0ocX4QT33cKnMpdniI9",
  MeetingRoomList = "vjUYNwjiqatf8vsw4gPyW",
}
